import Flow from "@/flows/flow";
import { VIEWS } from "@/common/constants";
import { buildAccountBaseService } from "@/common/service/base-paid";
import { getBasePlanInfo } from '@/common/product';
import { getAssignLicenseResult } from '@/common/service/validate/assign-license';
import { logger } from "@/utils/log";
import { buildShoppingCartWithPersist } from "@/common/service/plan-data-mapper";
import PageLoader from "@/common/service/flow/page-loader";

/**
 * Base Plan Downgrade
 * 1. Pro downgrade to basic plus
 * 2. Biz downgrade to pro
 * 3. Biz downgrade to pro plus
 * 4. Biz Plus downgrade to pro plus
 * 
 */
class DowngradeFlow extends Flow {
  hasValidCache = false
  loader = null

  source_plans(boughtPlans) {
    return getBasePlanInfo(boughtPlans).plans;
  }
  async __get_plans_assign_info(boughtPlans) {
    const plans = this.source_plans(boughtPlans);
    let assignResult = {};
    if (!plans.length) return assignResult;
    try {
      assignResult = await getAssignLicenseResult(plans[0], plans.map(item => item.plan_code));
    } catch (err) {
      logger.error(err);
    }
    return assignResult;
  }
  async df_fetch_data() {
    const { planMap, subscriptions, boughtPlans, freeTrialPlans, allPlanMap } = await buildAccountBaseService();
    const assignResult = await this.__get_plans_assign_info(boughtPlans);
    return {
      planMap, 
      subscriptions, 
      boughtPlans, 
      freeTrialPlans, 
      allPlanMap,
      assignResult
    }
  }

  async init_shopping_cart__hook() {
    throw new Error("You must override this method in a subclass");
  }

  view() { return VIEWS.COMPOUND }
  async init(state) {
    // load data
    // ready!!
    const res = await this.df_fetch_data()
    let {
      planMap, 
      subscriptions, 
      boughtPlans, 
      freeTrialPlans, 
      allPlanMap,
      assignResult
    } = res;

    let nextPlans = planMap;

    const { persist } = state;
    this.loader = new PageLoader(planMap);
    // try build cart with session storage.
    nextPlans = buildShoppingCartWithPersist(planMap, persist);
    this.hasValidCache = nextPlans !== null;
    if (!this.hasValidCache) {
      this.init_shopping_cart__hook(res);
      nextPlans = await this.loader.dispatch();
    }

    return {
      allPlanMap,
      boughtPlans,
      subscriptions,
      freeTrialPlans,
      planMapFlat: nextPlans,
      assignResult,
    }
  }
  beforeSubmit() { return () => {} }
  submit() {
    throw new Error("You must override this method in a subclass");
  }
}

export {
  DowngradeFlow
}
